import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';

const Contact = () => {
    useDocTitle('contact us');

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone_number: '',
        message: ''
    });

    const [status, setStatus] = useState('');
    const [sending, setSending] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);
        setStatus('');

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error('Failed to send message');
            }

            const result = await response.json();
            if (result.success) {
                setStatus('success');
                setFormData({ name: '', email: '', phone_number: '', message: '' });
            } else {
                setStatus('error');
            }
        } catch {
            setStatus('error');
        } finally {
            setSending(false);
        }
    };

    const inputClass =
        'w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-white/40 text-sm focus:outline-none focus:border-white/50 focus:bg-white/15 transition-all duration-200';

    const labelClass = 'block text-xs font-semibold text-white/60 uppercase tracking-widest mb-1.5';

    return (
        <>
            <NavBar />

            <div className="hero min-h-screen text-white flex flex-col items-center justify-center px-4 py-24">
                <div className="w-full max-w-lg mx-auto">

                    {/* Header */}
                    <div className="text-center mb-10">
                        <h1 className="text-4xl md:text-5xl font-semibold tracking-tight mb-3">
                            Get in Touch
                        </h1>
                        <p className="text-white/50 text-base">
                            We'd love to hear from you.
                        </p>
                    </div>

                    {/* Form card */}
                    <div className="bg-black/30 backdrop-blur-md border border-white/10 rounded-2xl p-8">
                        <form onSubmit={handleSubmit} className="space-y-5">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                <div>
                                    <label className={labelClass}>Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        placeholder="Your name"
                                        className={inputClass}
                                    />
                                </div>
                                <div>
                                    <label className={labelClass}>Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        placeholder="you@example.com"
                                        className={inputClass}
                                    />
                                </div>
                            </div>

                            <div>
                                <label className={labelClass}>Phone Number</label>
                                <input
                                    type="tel"
                                    name="phone_number"
                                    value={formData.phone_number}
                                    onChange={handleChange}
                                    required
                                    pattern="[0-9]{10}"
                                    placeholder="10-digit number"
                                    title="Please enter a valid 10-digit phone number"
                                    className={inputClass}
                                />
                            </div>

                            <div>
                                <label className={labelClass}>Message</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    placeholder="Write your message here..."
                                    rows={5}
                                    className={`${inputClass} resize-none`}
                                />
                            </div>

                            <button
                                type="submit"
                                disabled={sending}
                                className="w-full bg-white text-gray-900 font-semibold text-sm py-3 rounded-lg hover:bg-white/90 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed mt-1"
                            >
                                {sending ? 'Sending...' : 'Send Message'}
                            </button>
                        </form>

                        {status === 'success' && (
                            <div className="mt-5 flex items-center gap-2.5 bg-white/10 border border-white/20 rounded-lg px-4 py-3">
                                <svg className="w-4 h-4 text-white flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                <p className="text-sm text-white/80">Message sent — we'll be in touch soon.</p>
                            </div>
                        )}

                        {status === 'error' && (
                            <div className="mt-5 flex items-center gap-2.5 bg-white/10 border border-white/20 rounded-lg px-4 py-3">
                                <svg className="w-4 h-4 text-white/60 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                <p className="text-sm text-white/60">Something went wrong — please try again later.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Contact;
